package Structs

class Respone<K, V>(val first: K, val second: V) {

}